import { RouteRecordRaw } from 'vue-router'
import { requireAdmin } from '@/utils/authToken'

export const rProtected: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'search',
    component: () => import('@/views/account/SearchPage.vue')
  },
  {
    path: 'users',
    name: 'users',
    component: () => import('@/views/account/UserListPage.vue')
  },
  {
    path: '/reports',
    name: 'reports-error',
    component: () => import('@/views/account/DashboardPage.vue')
  },
  {
    path: 'reports/:id',
    name: 'reports',
    component: () => import('@/views/account/DashboardPage.vue')
  },
  {
    path: 'core-usage',
    name: 'core-usage',
    component: () => import('@/views/account/CoreUsagePage.vue'),
    beforeEnter: requireAdmin
  },
  {
    path: 'user-admin',
    name: 'user-admin',
    component: () => import('@/views/account/UserAdminPage.vue'),
    beforeEnter: requireAdmin
  },
  {
    path: 'dns-options',
    name: 'dns-options',
    component: () => import('@/views/account/DnsOptionsPage.vue'),
    beforeEnter: requireAdmin
  },
  {
    path: 'packages',
    name: 'packages',
    component: () => import('@/views/account/PackagesPage.vue'),
    beforeEnter: requireAdmin
  },
  {
    path: 'change-password',
    name: 'Change Password',
    component: () => import('@/views/account/ChangePasswordPage.vue')
  }
]
